import {
  createContext,
} from 'react'

const FieldGroupContext = (
  createContext({
    fieldGroups: [],
  })
)

export default FieldGroupContext
